
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28.8","height":"24","data-name":"グループ 577"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#12b6d4","d":"M14.4 24a1.2 1.2 0 01-1.2-1.2v-3H9.9A9.9 9.9 0 019.9 0h9a9.919 9.919 0 019.9 9.811V9.9a9.909 9.909 0 01-9.618 9.893l-3.94 3.865A1.2 1.2 0 0114.4 24M9.9 2.405a7.492 7.492 0 100 14.984h4.5a1.2 1.2 0 011.2 1.2v1.341l2.242-2.2a1.2 1.2 0 01.842-.344h.216A7.5 7.5 0 0026.395 9.9v-.042A7.508 7.508 0 0018.9 2.405z","data-name":"パス 744"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M8.531 8.384a1.467 1.467 0 101.467 1.472 1.468 1.468 0 00-1.466-1.467","data-name":"パス 745"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M14.399 8.384a1.467 1.467 0 101.467 1.467 1.467 1.467 0 00-1.467-1.467","data-name":"パス 746"}}),_c('path',{attrs:{"fill":"#12b6d4","d":"M20.268 8.384a1.467 1.467 0 101.467 1.467 1.467 1.467 0 00-1.467-1.467","data-name":"パス 747"}})])
          )
        }
      }
    